import { compose } from "redux";
import groupBy from "../../../helpers/groupBy";
import sortByProp from "../../../helpers/sortByProp";
import normalizedFirstChar from "../../../helpers/normalizedFirstChar";

const keyFromChar = char => (/[a-z]/.test(char) ? char : "#");

const keyFromFirstChar = compose(keyFromChar, normalizedFirstChar);

export const groupByFirstCharOfTitle = items =>
  groupBy(items, ({ title }) => keyFromFirstChar(title));

export const titleLinkAndChannelExclusions = ({
  content,
  link,
  channelExclusions
}) => ({
  title: content.title,
  linkUrl: link.webUrl,
  channelExclusions
});

export const byTitle = sortByProp(x => x.title.toLowerCase());

export const byKey = ([a], [b]) => {
  const ka = a.toLowerCase();
  const kb = b.toLowerCase();

  if (ka === "#") {
    return 1;
  }
  if (kb === "#") {
    return -1;
  }

  if (ka < kb) {
    return -1;
  }
  if (ka > kb) {
    return 1;
  }

  return 0;
};
